import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface GetCallerSendOtpRequest extends Partial<AxiosRequestConfig> {
  params: {
    code: string
    number: string
  }
}

export interface GetCallerSendOtpResponse extends AxiosResponse {
  data: {
    message: string
  }
}

export function getCallerSendOtpApi(
  { params, method = "get", ...config }: GetCallerSendOtpRequest,
  axiosInstance: AxiosInstance,
): Promise<GetCallerSendOtpResponse> {
  let url = ""
  if (params.code && params.number) {
    url = `auth/mobile/${params.code}/${params.number}/otp`
  }
  return axiosInstance({
    method,
    url,
    ...config,
  })
}
